import Dashboard from '../../components/ManageBin/Bin/Dashboard';

const DashboardPage=({userData})=>{
    return(
        <div>
            <Dashboard userData={userData}/>
        </div>
    );
};
export default DashboardPage;